import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { GlobalComponent } from '../../global/global.component';
import { FilterSettingsModel, IFilter, GridComponent, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { DataStateChangeEventArgs, SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ClearingHouseList, functionpermission, searchfilterDetails, sortingObj, GroupPayorList, DropList, ClearingHousePayorMapping, GetCHListBo, WhereCondition, columnWidth, ColumnChangeBO } from './clearing-house.model';
import { ToastrService } from 'ngx-toastr';

import { Observable } from 'rxjs';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
import { GeneralService } from 'src/app/service/general.service';
@Component({
  selector: 'app-clearing-house',
  templateUrl: './clearing-house.component.html',
  styleUrls: ['./clearing-house.component.scss'],
})
export class ClearingHouseComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  Clearing_House_Array: ClearingHouseList[];
  ClearH: ClearingHouseList = new ClearingHouseList();
  GroupPayorArray: GroupPayorList[];
  GroupPayer = [];
  senderidQualifier = [];
  isSaveorUpdateBoolean:boolean=false;
  RecieveridQualifier = [];
  format_type = [];
  clearing_form = {};
  ClearingHousePayorMapping_Array: ClearingHousePayorMapping[];
  ClearHMap_Array: ClearingHousePayorMapping = new ClearingHousePayorMapping();
  payordetail = [];
  CHSendBO: GetCHListBo = new GetCHListBo();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  StatusList: [{ Key: number, Value: string }]
  ColumnArray: columnWidth[]
  ClearingDataList: any = [];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  ClearingHouseFilterstatus: string = "Active";
  arraycol: any = [];
  clearHouseForm = new FormGroup({
    ClearingHouseId: new FormControl('', Validators.required),
    Name: new FormControl('', Validators.required),
    Modifier: new FormControl(''),
    FormatTypeLid: new FormControl(''),
    TradingPartnerID2: new FormControl(''),
    ReceiverIDQualifierLid: new FormControl('', Validators.required),
    ReceiverID: new FormControl('', Validators.required),
    SenderID: new FormControl('', Validators.required),
    SenderIDQualifier: new FormControl('', Validators.required),
    FileNameFormatType: new FormControl(''),
    ClearingHousePayorMapping: new FormArray([
    ]),
  });
  filterItems: { [key: string]: string } = {
    'clearingHouseId': 'ID',
    'name': 'Name',
    'modifier': 'Modifier',
    'senderId': 'Sender_Id',
    'senderIdQualifier_Name': 'SenderIdQualifier_Name',
    'receiverId': 'ReceiverId',
    'receiverIDQualifier_Name': 'ReceiverIDQualifier_Name',
  };
  SearchText: string = '';
  SearchColumn: { [key: string]: string } = { 'name': 'Name' };
  @ViewChild('grid') public grid: GridComponent;
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: object;
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  clearinghouseStatus: string;
  Filter_drop: searchfilterDetails;
  TotalCount: number;
  pagshort: sortingObj = new sortingObj();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  valuechange: any = [];
  deleteId: string = '';
  index: number;
  ModelType: string = 'edit';
  fp: functionpermission;
  isShowDivIf: boolean = false;
  constructor(public http: HttpClient,public global: GlobalComponent, public CommonAPI: CommonApiService, public toastrService: ToastrService, public general: GeneralService) {
    this.global.agencyList();
    this.data = CommonAPI;
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CHSendBO.orderColumn = state.sorted[0].name;
        this.CHSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.CHSendBO.field = state.action.currentFilterObject.field;
      this.CHSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.CHSendBO.operator = state.action.currentFilterObject.operator;
      this.CHSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CHSendBO.field = "name";
        this.CHSendBO.matchCase = false;
        this.CHSendBO.operator = "startswith";
        this.CHSendBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Clearinghouse.Pagesize != state.take) {
          this.arraycol[0].Clearinghouse.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
    this.getClearingHouse();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      this.SaveColumnwidth();
    }
  }
  ngOnInit(): void {
    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.SearchColumn.key = 'name';
    this.SearchColumn.value = 'Name';
    this.getTotalCount();
    this.getFormat_type();
    this.getGroupPayor();
    this.getReceiver_id_qualifier();
    this.getSenderIdQualifier();
    this.getClearingHouse();
    this.fp = new functionpermission();
    this.filepermissionget();
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Clearinghouse.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Clearinghouse.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].Clearinghouse.ShowColumns.length != count1 || this.arraycol[0].Clearinghouse.HideColumns.length != count) {
          this.arraycol[0].Clearinghouse.ShowColumns = showarr;
          this.arraycol[0].Clearinghouse.HideColumns = hidearr;
          this.SaveColumnwidth();
        }
      }
    }
    this.CHSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.CHSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  getClearingHouse() {
    if (this.ClearingHouseFilterstatus == "Active") {
      this.CHSendBO.isinActive = false;
    }
    else if (this.ClearingHouseFilterstatus == "InActive") {
      this.CHSendBO.isinActive = true;
    }
    else {
      this.CHSendBO.isinActive = null;
    }
    let url = "api/ClearingHouse/GetClearingHouseList?"
    let responseData =
    {
      result: "chList",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.CHSendBO, responseData,"");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClearingDataList = data.result;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
          // this.getColumnwidth();
        }
      }
    })

  }
  getGroupPayor() {
    let params = new URLSearchParams();
    let url = "api/Payer/GetGroupPayorList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: GroupPayorList[]) => {
      this.GroupPayorArray = data;
    })
  }
  getSenderIdQualifier() {
    let params = new URLSearchParams();
    params.append("Code", "SENDERIDQUALIFIER");
    let url = "api/LOV/LovDropDownQualifier?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: DropList[]) => {
      this.senderidQualifier = data;
    })
  }
  getReceiver_id_qualifier() {
    let params = new URLSearchParams();
    params.append("Code", "RECEIVERID_QUALIFIER");
    let url = "api/LOV/LovDropDownQualifier?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: DropList[]) => {
      this.RecieveridQualifier = data;
    })
  }
  getFormat_type() {
    let params = new URLSearchParams();
    params.append("ListCode", "FormatType");
    let url = "api/LOV/getLovDropDown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any) => {
      this.format_type = data;
    })
  }
  getTotalCount() {
    let params = new URLSearchParams();
    params.append("SearchColumn", this.SearchColumn.key);
    params.append("SearchText", this.SearchText);
    let url = "api/ClearingHouse/GetClearingHouseList_Count?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.TotalCount = data;
    });
  }
  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
        'name': 'Name'
      };
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }
  // Search Filter //
  Search() {
    this.CHSendBO.field = this.SearchColumn.key;
    this.CHSendBO.value = this.SearchText;
    this.CHSendBO.pageitem = 10;
    this.CHSendBO.currentpageno = 1;
    this.pagshort.currentPgNo = 1;
    this.getClearingHouse();
  }
  // Refresh Option //
  Refresh() {
    this.SearchText = "";
    this.CHSendBO.field = 'name';
    this.CHSendBO.value = "";
    this.CHSendBO.pageitem = 10;
    this.CHSendBO.currentpageno = 1;
    this.pagshort = new sortingObj();
    this.ClearingHouseFilterstatus = "Active"
    this.getClearingHouse();
    this.getTotalCount();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  OpenCreateupdate(type: string) {
    this.valueschanges();
    if (type == 'new') {
      this.ModelType = 'new';
      this.clearinghouseStatus = "saveActive";
      this.clearHouseForm.reset();
      this.ClearH = new ClearingHouseList();
      this.clearHouseForm.setControl('ClearingHousePayorMapping', new FormArray([]));
      this.valueschanges();
    }
    else {
      this.valueschanges();
      this.ModelType = 'edit';
    }
  }
  selectCHDetails(CHDetails: ClearingHouseList) {
    this.ClearH = JSON.parse(JSON.stringify(CHDetails));
    if (this.ClearH.isinActive == false) {
      this.clearinghouseStatus = "saveActive";
    }
    else {
      this.clearinghouseStatus = "saveInActive";
    }
    this.ModelType = 'edit';
    let params = new URLSearchParams();
    params.append("ClearingHouseId", CHDetails.id.toString());
    this.clearHouseForm.setControl('ClearingHousePayorMapping', new FormArray([]));
    let url = "api/ClearingHousePayorMapping/GetClearingHousePayorMappingList_withId?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClearingHousePayorMapping[]) => {
      this.ClearH.clearingHousePayorMapping = data;
      for (let i = 0; i < data.length; i++) {
        let creds = this.clearHouseForm.get('ClearingHousePayorMapping')['controls'];
        data[i].groupPayorId = data[i].groupPayorId;
        creds.push(new FormGroup({
          GroupPayor: new FormControl(data[i].groupPayorId),
          GroupPayorId: new FormControl(data[i].payorID),
          Status: new FormControl(data[i].status),
        }));
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err.error, 'Error'), 8000;
      }
    })
  }
  setPayorId(i) {
    let credarray = this.clearHouseForm.get('ClearingHousePayorMapping')['controls'];
    let id = credarray[i].controls['GroupPayor'].value;
    credarray[i].controls['GroupPayor'].setValue(id);
    for (let index = 0; index < this.GroupPayorArray.length; index++) {
      if (this.GroupPayorArray[index].id == id) {
        credarray[i].controls['GroupPayorId'].setValue(this.GroupPayorArray[index].payorId);
      }
    }
    this.ClearH.clearingHousePayorMapping[i].groupPayorId = id;
  }
  SaveOrUpdateClearnhHouse() {
    this.isSaveorUpdateBoolean=true
    if (this.clearinghouseStatus == "saveActive") {
      this.ClearH.isinActive = false;
    }
    else if (this.clearinghouseStatus == "saveInActive") {
      this.ClearH.isinActive = true;
    }
    this.ClearH.formatTypeLid = this.ClearH.formatTypeLid != null ? this.ClearH.formatTypeLid : null;
    this.ClearH.senderIDQualifierLid = this.ClearH.senderIDQualifierLid;
    this.ClearH.receiverIDQualifierLid = this.ClearH.receiverIDQualifierLid;
    if (this.ClearH.clearingHousePayorMapping.length > 0) {
      for (let i = 0; i < this.ClearH.clearingHousePayorMapping.length; i++) {
        if (this.ClearH.clearingHousePayorMapping[i].groupPayorId == null || this.ClearH.clearingHousePayorMapping[i].groupPayorId == '00000000-0000-0000-0000-000000000000') {
          this.ClearH.clearingHousePayorMapping.splice(i, 1);
        }
      }
    }
    let url = "api/ClearingHouse/SaveClearingHouse";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.ClearH,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: string) => {
     this.isSaveorUpdateBoolean=false
      this.valueschanges();
      if (data) {
        if (this.ModelType == 'new') {
          this.ClearH.id = data;
          document.getElementById('openModal1').click();
          this.toastrService.success(
            "Clearing house saved successfully!"), 8000
        } else {
          document.getElementById('openModal1').click();
          this.toastrService.success(
            "Clearing house updated successfully!"), 8000
        }
        this.getClearingHouse();
      }
    },
      (Err: any) => {
        this.isSaveorUpdateBoolean=false
        this.toastrService.error(Err, 'Error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  addFieldValue() {
    const creds = this.clearHouseForm.controls.ClearingHousePayorMapping as FormArray;
    creds.push(new FormGroup({
      GroupPayor: new FormControl(),
      GroupPayorId: new FormControl(),
      Status: new FormControl(),
    }));
    this.ClearH.clearingHousePayorMapping.push(
      this.ClearHMap_Array
    );
    }
  deleteFieldValue(index) {
    const creds = this.clearHouseForm.controls.ClearingHousePayorMapping as FormArray;
    creds.removeAt(index);
    this.ClearH.clearingHousePayorMapping.pop();
  }
  deleteFieldValue_update(index) {
    const creds_form = this.ClearH.clearingHousePayorMapping;
    const creds = this.clearHouseForm.controls.ClearingHousePayorMapping as FormArray;
    this.index = index;
    if (creds_form[index].id == null) {
      creds.removeAt(index);
      this.ClearH.clearingHousePayorMapping.pop();
    }
    else {
      this.deleteId = creds_form[index].id.toString();
      document.getElementById("openModal3").click();
    }
  }
  deleteClearingHousePayorMapping() {
    let params = new URLSearchParams();
    params.append("CleasingHousepayorId", this.deleteId);
    let url = "api/ClearingHousePayorMapping/DeleteClearingHousePayorMapping/";
    this.CommonAPI.DeleteFunctionForGetHttp(parseInt(this.deleteId),url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.valueschanges();
      document.getElementById("openModal3").click();
      this.toastrService.success(
        "Clearing house payor mapping deleted successfully!"), 8000
      const creds = this.clearHouseForm.controls.ClearingHousePayorMapping as FormArray;
      creds.removeAt(this.index);
    });
  }
  onStatusChange(i) {
    let credarray = this.clearHouseForm.get('ClearingHousePayorMapping')['controls'];
    let status = credarray[i].controls['Status'];
    this.ClearH.clearingHousePayorMapping[i].status = status.value;
  }
  // ===================================Closing a model from ts============//
  valueschanges() {
    this.valuechange = {
      Id: 0,
      Name: 0,
      Modifier: 0,
      FormatTypeLid: 0,
      TradingPartnerID2: 0,
      SenderID: 0,
      SenderIDQualifierLid: 0,
      ReceiverID: 0,
      ReceiverIDQualifierLid: 0,
      FileNameFormatType: 0,
      GroupPayor: 0,
    }
  }
  checkpopup(value) {
    if (value == "Id") {
      this.valuechange.Id++;
    }
    if (value == "Name") {
      this.valuechange.Name++;
    } if (value == "Modifier") {
      this.valuechange.Modifier++;
    } if (value == "FormatTypeLid") {
      this.valuechange.FormatTypeLid++;
    }
    if (value == "TradingPartnerID2") {
      this.valuechange.TradingPartnerID2++;
    }
    if (value == "SenderID") {
      this.valuechange.SenderID++;
    }
    if (value == "SenderIDQualifierLid") {
      this.valuechange.SenderIDQualifierLid++;
    }
    if (value == "ReceiverID") {
      this.valuechange.ReceiverID++;
    }
    if (value == "ReceiverIDQualifierLid") {
      this.valuechange.ReceiverIDQualifierLid++;
    }
    if (value == "FileNameFormatType") {
      this.valuechange.FileNameFormatType++;
    }
    if (value == "GroupPayor") {
      this.valuechange.GroupPayor++;
    }
  }
  CloseSaveMOdelConfirm() {
    if (this.valuechange.Id > 1 || this.valuechange.Name > 1 || this.valuechange.Modifier > 1 ||
      this.valuechange.FormatTypeLid > 1 || this.valuechange.TradingPartnerID2 > 1 || this.valuechange.SenderID > 1
      || this.valuechange.SenderIDQualifierLid > 1 || this.valuechange.ReceiverID > 1 || this.valuechange.ReceiverIDQualifierLid > 1
      || this.valuechange.FileNameFormatType > 1 || this.valuechange.GroupPayor > 0) {
      document.getElementById('cancelmodal').click();
    }
    else {
      document.getElementById('openModal1').click();
    }
  }
  closeAddUpdateModal() {
    document.getElementById('cancelmodal').click();
    document.getElementById('openModal1').click();
  }
  filepermissionget() {
    let params = new URLSearchParams();
    params.append("pagecode", "ClearingHouse");
   // params.append("roleId", this.global.roleId);
   let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: functionpermission) => {
      this.fp = data;
    });
  }
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Clearinghouse.Columns;
    this.grid.columns.forEach(col => {
      this.arraycol[0].Clearinghouse.HideColumns.forEach(element => {
        if (col.headerText == element) {
          col.visible = false;
        }
      });
    });
    this.grid.hideColumns(this.arraycol[0].Clearinghouse.HideColumns);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].Clearinghouse.Pagesize;
    this.ColumnArray.forEach(element => {
      if (element.column == 'Name') {
        const column = this.grid.getColumnByField('name');
        column.headerText = element.column;
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Modifier') {
        const column1 = this.grid.getColumnByField('modifier');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Fax') {
        const column2 = this.grid.getColumnByField('fax');
        column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Receiver Id Qualifier') {
        const column3 = this.grid.getColumnByField('receiverIDQualifier_Name');
        column3.headerText = element.column;
        column3.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Receiver Id') {
        const column4 = this.grid.getColumnByField('receiverId');
        column4.headerText = element.column;
        column4.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Sender Id Qualifier') {
        const column5 = this.grid.getColumnByField('senderIdQualifier_Name');
        column5.headerText = element.column;
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Sender Id') {
        const column5 = this.grid.getColumnByField('senderId');
        column5.headerText = element.column;
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Format Type') {
        const column6 = this.grid.getColumnByField('formatTypeName');
        column6.headerText = element.column;
        column6.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'File Name Format Type') {
        const column7 = this.grid.getColumnByField('fileNameFormatType');
        column7.headerText = element.column;
        column7.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Trading Partner ID2') {
        const column8 = this.grid.getColumnByField('tradingPartnerID2');
        column8.headerText = element.column;
        column8.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Actions') {
        const column2 = this.grid.getColumnByUid('action');
        column2.width = element.width;
        this.grid.refreshHeader();

      }
    });

  }
  SaveColumnwidth() {
    // this.arraycol[0].Clearinghouse.Columns = this.ColumnArray;
    // this.arraycol[0].Clearinghouse.Pagesize = this.grid.pageSettings.pageSize;


    // this.columnchange.userid = parseInt(this.global.userID);
    // this.columnchange.column = JSON.stringify(this.arraycol);
    // this.columnchange.id = this.id;

    // this.global.globalColumn = this.columnchange;
    // this.arraycol = JSON.parse(this.global.globalColumn.column);
    // let url = "api/ColumnChange/Savewidth?";
    // this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   this.getColumnwidth();
    // });
  }
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

